export default {"src":"/_next/static/media/logomark_ivory.4e4d638c.svg","height":82,"width":81,"blurWidth":0,"blurHeight":0};